<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear indeterminate />
      </v-card-text>
    </v-card>

    <v-card flat v-else>
      <ReportViewBar title="Department Balance" />

      <v-card-text>
        <v-btn depressed class="mb-3" @click="loadData">
          Reload
        </v-btn>

        <v-data-table
          dense
          :headers="headers"
          :items="Department"
          :items-per-page="Department.length"
          hide-default-footer
        >
          <template v-slot:item.totalParentPay="{ item }">
            <span class="font-weight-bold red--text">
              {{ Number(item.totalParentPay || 0) | currency }}
            </span>
          </template>

          <template v-slot:body.append>
            <tr style="background-color:#CFD8DC">
              <td class="text-right font-weight-bold">
                Result Total
              </td>
              <td class="text-right font-weight-bold">
                {{ fullTotalDue | currency }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import reportService from "@/modules/ReportView/service.js";

export default {
  components: {
    ReportViewBar,
  },

  data() {
    return {
      isLoading: true,
      Department: [],
      fullTotalDue: 0,
      headers: [
        {
          text: "DEPARTMENT",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "BALANCE",
          align: "right",
          value: "totalParentPay",
          sortable: true,
        },
      ],
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.isLoading = true;

      return reportService.balanceByDepartment({ due: true })
        .then((response) => {
          this.Department = response.data || [];

          this.fullTotalDue = this.Department.reduce((sum, row) => {
            return sum + Number(row.totalParentPay || 0);
          }, 0);

          return response;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>